document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.kh-menu-toggle');
  const menu = document.querySelector('.kh-main-nav');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.classList.toggle('is-open', !open);
    });
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const price = document.querySelector('[data-product-price]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
    });
  });

  document.querySelectorAll('.kh-product-description').forEach((description) => {
    const hasRichFormatting = description.querySelector('p, ul, ol, h2, h3, h4, br, table');
    if (!hasRichFormatting) description.classList.add('kh-product-description--plain');
  });
});
